import Env from "../base/env.js";
import Channels from "../base/channels.js";
import Launcher from "../view/launcher";
import UISwitcher from "../ui/UISwitcher";
import SmoothieLenis from "../fx/SmoothieLenis";
import { RevealFadeOut } from "../fx/Common";

class UI {
  constructor() {
    if (typeof history.scrollRestoration != "undefined") {
      history.scrollRestoration = "manual";
    }
    this.launcher = new Launcher();
    this.detectAppHeight();
    this.resetEnv();
    this.uiSwitch = new UISwitcher();

    // Smooth
    this.smoothie = new SmoothieLenis();
    this.smoothie.setup();

    this.mailMorph();

    RevealFadeOut(document.getElementById("setupUI"));
  }

  appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  }

  detectAppHeight() {
    this.appHeight();
    Channels.on("window::smartresize", this.appHeight);
  }
  mailMorph() {
    for (let item of document.querySelectorAll(".js-mailmorph")) {
      const getText = item.getAttribute("data-href");
      const baseText = item.innerHTML;
      let morphText = getText
        .replace("[AT]", "@")
        .replace("[DOT]", ".")
        .replace("[DOT]", ".");
      item.setAttribute("href", "mailto:" + morphText);
      if (Env.mobileCSS == false) {
        item.addEventListener("mouseenter", () => {
          item.innerHTML = morphText;
        });
        item.addEventListener("mouseleave", () => {
          item.innerHTML = baseText;
        });
      }
    }
  }

  resetEnv() {
    Channels.on("statechange::before", function () {
      Env.$html.classList.remove("mainnav--isOpened");
      Env.$html.classList.remove("subnav--isOpened");
    });
    Channels.on("statechange::ready", (current, old, container) => {
      Env.isVisiting = true;
      this.smoothie.populate();
      // Env.$html.classList.remove('skin--isWhite')
      // Env.$html.classList.remove('skin--isDark')
      // Env.$mainNav.classList.remove('is--active');
      // Env.$html.classList.remove('mainnav--isOpened')
    });
    Channels.on("statechange::finalize", () => {});
  }
}

export default UI;
